<template>
  <div class="wrapper">
    <van-tabs sticky animated :line-width="20" :swipeable="true" v-model="active">
      <van-tab :title="menu[0].totalRows==0?'未领取':`未领取(${menu[0].totalRows})`">
        <van-list
          class="scroll"
          :immediate-check="false"
          :finished-text="menu[0].list.length?'没有更多了':''"
          v-model="menu[0].loading"
          :finished="menu[0].finished"
          @load="getdata"
          :offset="20"
          id="scroll"
        >
          <div class="item" v-for="(item ,index) in menu[0].list" :key="index">
            <div class="top">
              <div class="left" @click="showImage(item.prize_image)">
                <img :src="item.prize_image" alt />
              </div>
              <div class="right">
                <div class="title">{{item.prize_name}}</div>
                <div class="bottom" v-if="item.prize_type<2">
                  <span>规格：{{item.property_simple}}</span>
                </div>
              </div>
            </div>
            <div class="bottomArea">
              <span>中奖时间：{{item.create_time}}</span>
              <div class="button" @click="toGetReward(item.record_nbr)" v-if="item.prize_type<2">
                <span>领取奖品</span>
              </div>
            </div>
          </div>
          <div class="noData" v-if="menu[0].list.length == 0&&isLoading">
            <img src="./../../assets/images/turn/noData.png" alt />
            <span>暂无未领取奖品</span>
          </div>
        </van-list>
      </van-tab>
      <van-tab :title="menu[1].totalRows==0?'已领取':`已领取(${menu[1].totalRows})`">
        <van-list
          class="scroll"
          v-model="menu[1].loading"
          :immediate-check="false"
          :finished-text="menu[1].list.length?'没有更多了':''"
          :finished="menu[1].finished"
          @load="getdata"
          :offset="20"
          id="scroll"
        >
          <div class="itemCotainer" v-for="(item ,index) in menu[1].list" :key="index">
            <div class="item">
              <div class="top">
                <div class="left" @click="showImage(item.prize_image)">
                  <img :src="item.prize_image" alt />
                </div>
                <div class="right">
                  <div class="title">{{item.prize_name}}</div>
                  <div class="bottom" v-if="item.prize_type<2">
                    <span>规格：{{item.property_simple}}</span>
                  </div>
                </div>
              </div>
              <div class="bottomArea">
                <span>中奖时间：{{item.create_time}}</span>
                <div class="button" @click="toRewardDetail(item.record_nbr)" v-if="item.prize_type<2">
                  <span>查看详情</span>
                </div>
              </div>
            </div>
          </div>
          <div class="noData" v-if="menu[1].list.length == 0&&isLoading">
            <img src="./../../assets/images/turn/noData.png" alt />
            <span>暂无已领取奖品</span>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
    <!--选择地址弹窗-->
    <div class="address-popup" v-show="addressShow">
      <van-popup round position="bottom" v-model="addressShow" :overlay="true">
        <div class="addressBox">
          <div class="title" v-if="Object.keys(selectaddress).length > 0">
            <span class="left">地址信息</span>
            <div class="changeBtn">
              <span @click="toAddress">更换地址</span>
            </div>
          </div>
          <div class="noTitle" v-else>
            <span>请选择收货地址</span>
          </div>
          <div class="content">
            <div class="addressTop" v-if="Object.keys(selectaddress).length > 0">
              <span class="contacts">收货人：{{selectaddress.contacts}}</span>
              <span>{{selectaddress.phone_no}}</span>
            </div>
            <div
              class="addressBottom"
              v-if="Object.keys(selectaddress).length > 0"
            >地址：{{selectaddress.province||""}}{{selectaddress.city||""}}{{selectaddress.district||""}}{{selectaddress.address||""}}</div>
            <textarea v-model="message" @change="messageChange" v-if="Object.keys(selectaddress).length > 0" class="textArea" placeholder="备注：请填写您的备注信息"></textarea>
            <div class="noAddress" v-else>
              <span class="top">您还未添加地址，请先到地址管理中添加地址</span>
              <div class="btn" @click="toAddress"><span>前往地址管理</span></div>
            </div>
          </div>
          <div class="bottomBtn">
            <div class="cancel" @click="addressShow=false">
              <span>取消</span>
            </div>
            <div class="ok" @click="ok">
              <span>确定</span>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      pageType:'',
      gameNbr:'',
      active: 0, //初始显示那个类
      menu: [
        {
          list: [],
          pageIndex: 0,
          numPerPage: 10,
          totalRows: 0,
          loading: true, //上拉加载
          finished: false //加载完成
        },
        {
          list: [],
          pageIndex: 0,
          numPerPage: 10,
          totalRows: 0,
          loading: true, //上拉加载
          finished: false //加载完成
        }
      ],
      address:{},
      defaultAddress:{},
      message:'',
      rewardNbr: "", //选择的奖品nbr
      addressShow: false, // 地址弹窗
      keepAlive: false, // 缓存吗？
      switch: true, // 提交开关
      isLoading: false,
      toRefresh: false,
    };
  },
  watch: {
    $route(to, from) {
      if (from.path == "/addresslist") {
        this.keepAlive = true;
      } else {
        this.keepAlive = false;
      }

      if (from.path == "/turn") {
        this.toRefresh = true;
      } else {
        this.toRefresh = false;
      }
    },
    active(val, old) {
      this.menu[0].list = [];
      this.menu[1].list = [];
      this.menu[val].pageIndex = 0;
      this.menu[val].loading = true;
      this.menu[val].finished = false;
      this.getdata();
    }
  },
  computed: {
    ...mapGetters(["selectaddress"])
  },
  methods: {
    toRewardDetail(nbr){
      this.$router.push({ path: "/rewardDetail",query:{record:nbr,game:10000,supNbr:this.userInfo.nbr} });
    },
    messageChange(e){
      this.message = e.target.value;
    },
    showImage(img) {
      wx.previewImage({
        current: img,
        urls: [img]
      });
    },
    // 领奖品喽
    ok() {
      if(!this.selectaddress){
        return this.$toast({
            message: '请设置收货地址！',
            duration: 2000
        });
      }
      if (!this.switch) {
        return false;
      }
      this.switch = false;

      let params={
        jydm: "flow_10000",
        flow_10000: {
          sub_flow: "flow_90009",
          user_nbr: this.userInfo.nbr,
          record_nbr: this.rewardNbr,
          address_nbr: this.selectaddress.nbr,
          message: this.message,
        }
      }
      if(this.pageType=='game'){
        params.flow_10000.sub_flow="flow_90009"
      }else{
        params.flow_10000.sub_flow="flow_150029"
      }
      this.$commonPost(params)
        .then(response => {
          this.$toast({
            message: "领取成功",
            duration: 2000
          });
          this.active = 1;
          this.addressShow = false;
          this.rewardNbr = "";
          this.switch = true;
        })
        .catch(err => {
          this.switch = true;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    toAddress() {
      this.$router.push({ path: "/addresslist", query: { address: 1,supNbr:this.userInfo.nbr } });
    },
    toGetReward(nbr) {
      this.rewardNbr = nbr;
      this.addressShow = true;
    },
    getdata() {
      this.loading = true;
      let active = this.active;
      let menu = this.menu;
      this.isLoading = false;

      let params={}
      if(this.pageType=='game'){
        params={
          jydm: "flow_90008",
          flow_90008: {
            user_nbr: this.userInfo.nbr,
            game_nbr: this.gameNbr,
            state: active,
            page_index: menu[active].pageIndex * menu[active].numPerPage,
            num_per_page: menu[active].numPerPage
          }
        }
      }else{
        params={
          jydm: "flow_150025",
          flow_150025: {
            user_nbr: this.userInfo.nbr,
            state: active,
            page_index: menu[active].pageIndex * menu[active].numPerPage,
            num_per_page: menu[active].numPerPage
          }
        }
      }
      this.$commonPost(params)
        .then(response => {
          let arr = [];
          if (response.total_rows > 0) {
            if (response.game) {
              if (response.game.length > 1) {
                arr = response.game;
              } else {
                arr.push(response.game);
              }
            }
          }
          menu[active].list = menu[active].list.concat(arr);
          menu[active].pageIndex += 1;
          menu[0].totalRows = response.receive_total_rows;
          menu[1].totalRows = response.received_total_rows;
          if (
            menu[active].list.length >= response.total_rows ||
            menu[active].list.length == 0
          ) {
            menu[active].finished = true;
          }
          menu[active].loading = false;
          this.isLoading = true;
          this.menu = menu;
        })
        .catch(err => {
          this.isLoading = true;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getAddress(bool){
      // 用户的默认地址
      this.$commonPost({
        jydm: "flow_10010",
        flow_10010: {
          user_nbr: this.userInfo.nbr
        }
      })
        .then(response => {
          let obj = {};
          if (response.address) {
            obj = response.address;
          }
          if(!bool){
            this.address = obj;
            this.defaultAddress = obj;
          }
          if( Object.keys(obj).length > 0){
            if(JSON.stringify(this.defaultAddress)!=JSON.stringify(obj)){
              this.$store.commit("SENDselectaddress",obj);
            }else{
              this.$store.commit("SENDselectaddress",this.address);
            }
          }else{
            this.$store.commit("SENDselectaddress",{});
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    initPage(){
      let option = {
        title: '有米@'+this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl
      };
      this.weChatShare(option);
      if(this.toRefresh){
        this.menu = [
        {
          list: [],
          pageIndex: 0,
          numPerPage: 10,
          totalRows: 0,
          loading: true, //上拉加载
          finished: false //加载完成
        },
        {
          list: [],
          pageIndex: 0,
          numPerPage: 10,
          totalRows: 0,
          loading: true, //上拉加载
          finished: false //加载完成
        }
       ]
      }
      if (this.keepAlive) {
        if(!this.selectaddress){
          this.getAddress(true);
        }
        this.addressShow = true;
      } else {
        this.getdata();
        this.getAddress();
      }
    },
  },
  created() {
  },
  // 被缓存时任执行
  activated() {
    document.title = "我的奖品";
    this.gameNbr = this.$route.query.gameNbr||'10000'
    this.pageType = this.$route.query.type||'game'
    this.initPage()
  },
  mounted() {
     
  },
  beforeRouteLeave(to, from, next) {
    this.address = this.selectaddress;
    this.$store.commit("SENDselectaddress", "");
    next();
  }
};
</script>
<style scoped lang='stylus'>
.van-tabs >>> .van-tab {
  color: #101010;
  font-size: 0.28rem;
}

.van-tabs >>> .van-tab--active {
  color: #E52B25;
}

.address-popup >>> .van-popup {
  max-height: auto;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  overflow: hidden;
}
</style>
<style scoped lang='less'>
.wrapper {
  width: 100%;
}
.noData {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  img {
    margin-top: 1.7rem;
    width: 2.1rem;
    height: 2.42rem;
  }
  span {
    width: 100%;
    display: inline-block;
    text-align: center;
    margin-top: 0.3rem;
    color: #999;
    font-size: 0.28rem;
  }
}
.scroll {
  min-height: calc(100vh - 0.88rem);
  .item {
    width: 100%;
    padding: 0.24rem 0.24rem 0;
    box-sizing: border-box;
    border-bottom: 0.1rem solid #f5f5f5;
    .top {
      display: flex;
      justify-content: space-between;
      height: 1.5rem;
      padding-bottom: 0.24rem;
      border-bottom: 1px solid #eee;
      .left {
        width: 1.5rem;
        height: 1.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 1.5rem;
          height: 1.5rem;
          object-fit: cover;
        }
      }
      .right {
        width: 5.38rem;
        height: 1.5rem;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        .title {
          line-height: 0.32rem;
          font-size: 0.24rem;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
          white-space: normal;
          margin-bottom: 0.2rem;
        }
        .bottom {
          display: flex;
          justify-content: flex-between;
          flex-wrap: nowrap;
          align-items: center;
          position: relative;
          span {
            font-size: 0.24rem;
            color: #999;
            line-height: 0.33rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            word-break: break-all;
          }
        }
      }
    }
    .bottomArea {
      position: relative;
      height: 0.98rem;
      display: flex;
      align-items: center;
      span {
        font-size: 0.24rem;
        color: #333333;
        line-height: 0.33rem;
      }
      .button {
        width: 2.96rem;
        height: 1rem;
        background: #E52B25;
        border-radius: 0.5rem;
        position: absolute;
        top: 50%;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: scale(0.5) translate(-50%, -50%);
        transform-origin: 150% 0%;
        span {
          color: #fff;
          font-size: 0.48rem;
          line-height: 0.5rem;
          white-space: nowrap;
        }
      }
    }
  }
}
.address-popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  width: 100%;
}
.addressBox {
  height: 6.66rem;
  .title {
    width: 100%;
    height: 0.88rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 0 0.3rem;
    box-sizing: border-box;
    .left {
      font-size: 0.34rem;
      color: #333;
      font-weight: bold;
    }
    .changeBtn {
      width: 2.6rem;
      height: 0.96rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.48rem;
      border: 2px solid #E52B25;
      transform: scale(0.5);
      transform-origin: 100%;
      span {
        font-size: 0.48rem;
        color: #E52B25;
      }
    }
  }
  .noTitle{
    width: 100%;
    height: 0.88rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #eee;
    padding: 0 0.3rem;
    box-sizing: border-box;
    span{
      font-size: .34rem;
      color: #333;
      font-weight: bold;
    }
  }
  .content {
    padding: 0.3rem 0.4rem 0;
    height: 5.54rem;
    box-sizing: border-box;
    .noAddress{
      margin-top: 1.37rem;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction:column;
      .top{
        margin-bottom: .55rem;
        line-height: .4rem;
        font-size: .28rem;
        color: #666;
      }
      .btn{
        width: 6.88rem;
        height: 1.76rem;
        border: 2px solid #666666;
        border-radius: .88rem;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: scale(0.5);
        transform-origin: 50% 0%;
        span{
          font-size: .6rem;
          color: #333;
          line-height: 1.76rem;
        }
      }
    }
    .addressTop {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0.4rem;
      line-height: 0.4rem;
      margin-bottom: 0.2rem;
      span {
        color: #333;
        font-size: 0.28rem;
      }
      .contacts {
        display: inline-block;
        width: 4.5rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .addressBottom {
      line-height: 0.4rem;
      height: 0.8rem;
      font-size: 0.28rem;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
      white-space: normal;
    }
    .textArea {
      margin-top: 0.4rem;
      width: 6.66rem;
      background: #f5f5f5;
      font-size: 0.24rem;
      color: #333;
      display: inline-block;
      border: none;
      resize: none;
      padding: 0.16rem;
      box-sizing: border-box;
      word-break: break-all;
      line-height: 0.33rem;
      height: 1.8rem;
      border-radius: 0.1rem;
    }
    .textArea::-webkit-input-placeholder {
      /* WebKit browsers */
      color: #999;
      font-size: .24rem;
    }

    .textArea::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #999;
      font-size: .24rem;
    }

    .textArea:-ms-input-placeholder {
      /* Internet Explorer 10+ */
      color: #999;
      font-size: .24rem;
    }
  }
  .bottomBtn {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0.98rem;
    display: flex;
    .cancel {
      flex: 1;
      height: 100%;
      background: #333;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-weight: bold;
        font-size: 0.3rem;
        color: #fff;
      }
    }
    .ok {
      flex: 1;
      height: 100%;
      background: #E52B25;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-weight: bold;
        font-size: 0.3rem;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/myReward.vue